<template>
 <Head>
    <title> Create Skill | {{$page.props.appName}}</title>
    <meta name="description" :content="'Create skill ' + $page.props.appName">
  </Head>
  <div class="p-3">
    <div class="bg-gray-100 rounded-md shadow overflow-hidden max-w-3xl p-3">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label for="text-input-17" class="form-label">Skill name:</label>

            <input
              placeholder="Skill Name"
              v-model="this.form.skill_name"
              type="text"
              class="form-input"
            />
          </div>

          <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label for="text-input-17" class="form-label">Skill Groups:</label>

            <select
              name=""
              class="form-select"
              v-model="this.form.skill_group_id"
            >
              <option
                v-for="skillg in skillgroups"
                :value="skillg.id"
                :key="skillg.id"
              >
                {{ skillg.skill_group_name }}
              </option>
            </select>
          </div>
        </div>

        <div class="w-full">
          <button
            type="submit"
            class="bg-black text-white font-bold p-2 ml-6 mt-3 float-right"
            :disabled="form.processing"
          >
            CREATE SKILL
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from "@/Shared/Layout";
import Pagination from "@/Shared/Pagination";
import { Link } from "@inertiajs/inertia-vue3";
import { Head } from '@inertiajs/inertia-vue3'

export default {
  layout: Layout,
  components: { Link, Pagination,Head},
  props: {
    skillgroups: Object,
  },
  data() {
    return {
      url: "",
      form: this.$inertia.form({
        skill_name: null,
        skill_group_id: this.skillgroups[0].id,
      }),
    };
  },
  methods: {
    store() {
      this.form.post("/admin/skill/create");
    },
  },
};
</script>
     